<template>
  <v-container class="pt-0">
    <card-header></card-header>
    <vote class="mt-4"></vote>
    <v-layout justify-center wrap class="mt-3">
      <v-btn color="white" href="mailto:tulasvumonq@sitedeq.fr">
        <v-icon left color="primary">send</v-icon>Envoyez nous votre Q
      </v-btn>
      <v-btn color="white" :to="{name:'classement'}">
        <v-icon left color="primary">format_list_numbered</v-icon>Le classement des Q
      </v-btn>
    </v-layout>
  </v-container>
</template>
<script>
import CardHeader from "./header";
import Vote from "./vote";

export default {
  components: { CardHeader, Vote }
};
</script>
